import styled from "styled-components";

export const QuestionContainer = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* height: 636px; */
  padding: 11rem 0;
  /* &.container {
    padding-top: 11rem;
    padding-bottom: 11rem;
  } */

  @media (max-width: 1024px) {
    flex-direction: column;
    padding-top: 40px;
  }
  @media (max-width: 760px) {
    height: auto;
  }
  @media (max-width: 600px) {
    padding: 40px 0 60px 0;
  }
`;

export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: 112px;
  margin-top: 1.2rem;
  p {
    font-weight: 700;
    font-family: Peyda;
    font-size: 3.2rem;
    line-height: 5.6rem;
    color: var(--white-color);
    @media (max-width: 768px) {
      font-size: 1.4rem;
      line-height: 2rem;
    }
    @media (max-width: 600px) {
      font-size: 2.2rem;
    }
  }

  @media (max-width: 1350px) {
    width: 100%;
  }
  @media (max-width: 600px) {
    height: auto;
  }
`;

export const TitleContainer = styled.div`
  width: ${(props) => props.width || "23%"};
  position: relative;
  margin-bottom: 30px;
  span {
    display: inline-block;
    width: 11.11px;
    height: 21px;
    position: absolute;
    top: 52px;
    left: 98%;
    background-color: ${(props) => props.color || "#fff"};
  }
  h5 {
    font-size: 1.6rem;
    font-weight: 800;
    color: ${(props) => props.titleColor || "#FFFFFF"};
    opacity: ${(props) => props.opacity || "1"};
    margin-bottom: 0.6rem;
    font-family: Peyda;
  }
  p {
    font-size: 3.2rem;
    font-weight: 700;
    line-height: 5.6rem;
    font-family: Peyda;
    padding-right: 1.4rem;
    color: var(--text-color);
  }

  @media (max-width: 1024px) {
    width: 100%;
    h5 {
      font-size: 1.6rem;
    }
    p {
      margin-right: 10px;
    }
  }
  @media (max-width: 850px) {
    p {
      font-size: 2.6rem;
    }
  }
  @media (max-width: 600px) {
    margin-bottom: 24px;
    p {
      font-size: 2.2rem;
    }
  }
`;
